import React from "react";
import Container from "./styled";
import { IoClose } from "react-icons/io5";
import ChangeInputTabs from "./changeInputTabs";

export default class ReferidosStepTwo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      response: "",
      currentMode: "input1",
      dni: "",
      email: "",
      formErrors: {},
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  validateInputs = () => {
    let errors = {};

    if (this.state.currentMode === "input1") {
      if (!this.state.dni) {
        errors.dni = "Este campo es requerido.";
      } else if (this.state.dni.length < 8) {
        errors.dni = "DNI inválido.";
      }
    } else {
      if (!this.state.email) {
        errors.email = "Este campo es requerido";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.email)) {
        errors.email = "El email ingresado no es valido.";
      }
    }

    this.setState({ formErrors: errors });

    // Si el objeto errors está vacío, ir al paso siguiente.
    if (Object.keys(errors).length === 0) {
      this.props.nextStep();
      //this.props.nextStep
    }
  };

  getInputs(currentMode) {
    const inputs = {
      input1: (
        <div className="inputContainer">
          <label>DNI</label>
          <input
            placeholder="DNI"
            name="dni"
            onChange={this.handleInputChange}
            value={this.state.dni}
            className={this.state.formErrors.dni && "inputError"}
          ></input>
          <p>
            {this.state.formErrors.dni && (
              <span>{this.state.formErrors.dni}</span>
            )}
          </p>
        </div>
      ),
      input2: (
        <div className="inputContainer">
          <label>Correo electrónico</label>
          <input
            placeholder="janedoe@gmail.com"
            name="email"
            onChange={this.handleInputChange}
            value={this.state.email}
            className={this.state.formErrors.email && "inputError"}
          ></input>
          <p>
            {this.state.formErrors.email && (
              <span>{this.state.formErrors.email}</span>
            )}
          </p>
        </div>
      ),
    };
    return inputs[currentMode];
  }

  getTexts(currentMode) {
    const texts = {
      input1: (
        <p>
          ¡Estos $200 son para vos! Dejanos tu DNI así te los transferimos a tu
          CBU.
        </p>
      ),
      input2: (
        <p>
          ¡Tenés un 20% OFF en el Seguro que quieras! Dejanos tu email para
          enviarte el voucher.
        </p>
      ),
    };
    return texts[currentMode];
  }

  toggleInputs = (currentMode) => {
    this.setState({ currentMode });
  };

  render() {
    return (
      <Container>
        <div className="closeButtonContainer">
          <a onClick={this.props.handleClose}>
            <IoClose />
          </a>
        </div>
        <h3>¡Aprovechá nuestro programa de referidos!</h3>
        {this.getTexts(this.state.currentMode)}
        <ChangeInputTabs toggleInputs={this.toggleInputs}></ChangeInputTabs>
        {this.getInputs(this.state.currentMode)}
        <button id="referirButton" onClick={this.validateInputs}>
          Referir
        </button>
      </Container>
    );
  }
}
